import React from 'react';
import { AlertTriangle, Zap } from 'lucide-react';

const PriorityBadge = ({ priority, className = '' }) => {
  const priorityConfig = {
    'low': {
      label: 'Low',
      color: 'bg-gray-100 text-gray-700',
      icon: null
    },
    'medium': {
      label: 'Medium',
      color: 'bg-blue-100 text-blue-700',
      icon: null
    },
    'high': {
      label: 'High',
      color: 'bg-orange-100 text-orange-700',
      icon: AlertTriangle
    },
    'urgent': {
      label: 'Urgent',
      color: 'bg-red-100 text-red-700',
      icon: Zap
    }
  };

  const config = priorityConfig[priority] || priorityConfig['medium'];
  const Icon = config.icon;

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${config.color} ${className}`}>
      {Icon && <Icon className="h-3 w-3 mr-1" />}
      {config.label}
    </span>
  );
};

export default PriorityBadge;
